import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/timesheets/UserLeavesFlyout.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import classNames from 'classnames';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';
import { __, setTableParams } from '../../core/utils';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import { Element, ScrollLink, scrollSpy } from 'react-scroll';
import UserLeaveProperties from './UserLeaveProperties';

const mapStateToProps = (state) => {
  return {
    tab_opened: _.get(state.table, ['timesheets', 'tab']),
    clicked_row: _.get(state.table, ['timesheets', 'clicked_row']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.timesheets/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class UserLeavesFlyout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed_tabs: [], //fix for scrollSpy not working on init
      highlighted_tab: null,
      history_expanded: false,
    };

    this.highlight_timeout = null;

    this.tabs = ['properties'];

    this.tab_refs = [];
  }

  componentDidMount() {
    scrollSpy.update();

    if (this.props.tab_opened) {
      setTimeout(() => {
        this.tab_refs[this.props.tab_opened] &&
          this.tab_refs[this.props.tab_opened].click();

        setTableParams('timesheets', {
          tab: undefined,
        });
      }, 500);
    }
  }

  @autobind
  _toggleCollapseTab(tab) {
    this.setState({
      collapsed_tabs: _.xor(this.state.collapsed_tabs, [tab]),
    });
  }

  @autobind
  _highlightSection(section) {
    this.setState({ highlighted_tab: section }, () => {
      if (this.highlight_timeout) clearTimeout(this.highlight_timeout);

      this.highlight_timeout = setTimeout(() => {
        this.setState({ highlighted_tab: null });
      }, 200);
    });
  }

  @autobind
  _toggleCollapseTabs() {
    if (_.size(this.state.collapsed_tabs) == _.size(this.tabs)) {
      this.setState({
        collapsed_tabs: [],
      });
    } else {
      this.setState({
        collapsed_tabs: this.tabs,
      });
    }

    this.refs.scroll.scrollTop = 0;
  }

  render() {
    const { data, readAction } = this.props;

    const { collapsed_tabs, highlighted_tab } = this.state;

    const TabLink = ScrollLink((props) => (
      <span
        ref={(ref) => (this.tab_refs[props.target] = ref)}
        onClick={(e) => {
          this.setState({
            collapsed_tabs: _.reject(
              collapsed_tabs,
              (section) => section == props.target
            ),
          });

          this._highlightSection(props.target);

          props.onClick(e);
        }}
        className={props.className}
      >
        {props.children}
      </span>
    ));

    const Tab = (props) => (
      <TabLink
        target={props.target}
        activeClass={styles.active}
        to={props.target}
        spy={true}
        smooth={true}
        duration={500}
        container={this.refs.scroll}
      >
        {props.children}
      </TabLink>
    );

    return (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <div>
              <span>
                <strong>{data.user_name}: </strong>
                {data.leave_reason_name}
              </span>
            </div>
            <CloseBigIcon
              onClick={() =>
                setTimeout(
                  () =>
                    this.props.actions.setTableParams({
                      clicked_row: undefined,
                    }),
                  100
                )
              }
            />
          </div>
          <div className={styles.actions}></div>
        </div>

        <div className={styles.tabsWrapper}>
          <ArrowDownMiddleIcon
            className={classNames(
              styles.collapseAll,
              _.size(collapsed_tabs) == _.size(this.tabs) && styles.collapsed
            )}
            onClick={this._toggleCollapseTabs}
          />
          <div className={styles.tabs}>
            <Tab target='properties'>{__('timesheet.flyout.properties')}</Tab>
          </div>
        </div>
        <div className={styles.content} ref='scroll'>
          <Element
            name='properties'
            className={classNames(
              styles.section,
              highlighted_tab == 'properties' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('properties')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'properties') && styles.collapsed
                )}
              />
              {__('timesheet.flyout.properties')}
            </div>
            <UserLeaveProperties
              collapsed={_.includes(collapsed_tabs, 'properties')}
              data={data}
              readAction={readAction}
            />
          </Element>
        </div>
      </div>
    );
  }
}

export default UserLeavesFlyout;
